import {LeftOutlined} from '@ant-design/icons';
import {cn} from '@ds/helpers';

import ProStatus from 'modules/Services/PromotionCenter/Pro/components/common/ProStatus/ProStatus';

type ProHistoryItemProps = {
  subtitle: string;
  state: string;
  onClick?: () => void;
  noBorder?: boolean;
};

const ProHistoryItem: React.FC<ProHistoryItemProps> = ({subtitle, state, onClick, noBorder}) => {
  const isDeleted = state === 'DELETED';

  return (
    <button
      type="button"
      className="flex w-full px-4 pt-3 text-start focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange disabled:cursor-default"
      disabled={isDeleted}
      onClick={isDeleted ? undefined : onClick}
    >
      <span
        className={cn(
          'flex w-full items-center justify-between gap-0.5 pb-3',
          !noBorder && 'border-b border-gray-03'
        )}
      >
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="text-body-sm-emphasis text-neutral-fg">پرو</span>
          <span className="text-body-sm text-gray-34">{subtitle}</span>
        </span>
        <ProStatus value={state} />
        <span className="flex size-5 items-center justify-center text-gray-29">
          {isDeleted ? null : <LeftOutlined aria-hidden />}
        </span>
      </span>
    </button>
  );
};

export default ProHistoryItem;
